import { Component, Input, OnInit } from '@angular/core';
import { AvailableServices, MeetingViewModelService } from '@vendasta/integrations';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'meeting-scheduler-connect-with-zoom-button',
  templateUrl: './connect-with-zoom-button.component.html',
  styleUrls: ['./connect-with-zoom-button.component.scss'],
  standalone: false,
})
export class ConnectWithZoomButtonComponent implements OnInit {
  @Input() serviceKey: string;
  @Input() isMeetingApp = true; // Zoom is only used for meeting apps, default to true
  public readonly zoom = AvailableServices.ZOOM;
  signInText: string;
  isConnected$: Observable<boolean>;

  constructor(
    private readonly translate: TranslateService,
    private readonly meetingViewModelService: MeetingViewModelService,
  ) {}

  ngOnInit(): void {
    this.isConnected$ = this.meetingViewModelService.isServiceConnected$(AvailableServices.ZOOM);
    // Zoom is only used for meeting apps, so always use meeting app translation
    this.signInText = this.translate.instant('MEETING_SCHEDULER.MEETING_INTEGRATIONS.MEETING_APP_SIGN_IN');
  }
}
